import { jsx as _jsx } from "react/jsx-runtime";
import { Circle, Indicator } from "./styles";
export function Root({ onClick, id, checked, disabled, variant, size }) {
    return (_jsx(Circle, { id: id, variant: variant, checked: checked, onClick: onClick, disabled: disabled, size: size, children: checked && _jsx(Indicator, { variant: variant, disabled: disabled, size: size }) }));
}
//# sourceMappingURL=Root.js.map